<tp-marketplace-integration providerName="Azure" [isSubmitting$]="isSubmitting$" (setAccount)="setAzureAccount($event.team, $event.token)"/>
